import { render } from "./IndiceTuto.vue?vue&type=template&id=6efca400"
import script from "./IndiceTuto.vue?vue&type=script&lang=js"
export * from "./IndiceTuto.vue?vue&type=script&lang=js"

import "./IndiceTuto.vue?vue&type=style&index=0&id=6efca400&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__